// Nivel de logging por DEFECTO de la app, controlado desde el repo
// (NO depende de variables de entorno / .env que maneja infra).
//
// Cambialo y redeployá para ajustar qué se ve en la consola del navegador:
//   'debug'  -> todo (log, info, warn, error)
//   'info'   -> info, warn, error
//   'warn'   -> warn, error           <-- valor para PRODUCCIÓN
//   'error'  -> solo error
//   'silent' -> nada
//
// Precedencia (mayor a menor): localStorage 'logLevel' > REACT_APP_LOG_LEVEL > este valor.
export type LogLevel = 'debug' | 'info' | 'warn' | 'error' | 'silent';

export const DEFAULT_LOG_LEVEL: LogLevel = 'warn';
